module.exports = __webpack_public_path__ + "img/SHM_side_top.c26449d8.svg";